import groq from "groq";

const Manual = groq`
view == "manual" => employees[]->{
  title,
  _createdAt,
  "positionTitle": employeePosition.position,
  "positionTag": employeePosition.stilling[]->title,
  email,
  "image": image.asset->url,
  _type,
  phone,
  _rev,
  _id,
  _updatedAt
}
`;
const Department = groq`
"department": department[]->{
    ...,
    "employees": *[_type == "employee" && references(^._id)] {
      title,
      _createdAt,
      "positionTitle": employeePosition.position,
      "positionTag": employeePosition.stilling[]->title,
      email,
      "image": image.asset->url,
      _type,
      phone,
      _rev,
      _id,
      _updatedAt
    }
}
  `;

const All = groq`
view == "all" => *[_type == "employee"] {
  phone,
  email,
  _type,
  "image": image.asset->url,
  title,
  "positionTitle": employeePosition.position,
  "positionTag": employeePosition.stilling[]->title,
  "placement":placements[0]->title


}



`;

export const EmployeesTypeQuery = groq`
  _type == "EmployeesType" => {
    "departmentTitle": department[0]->title,
    ...,
    "employees": select(
      ${Manual},
      ${All}
    ),
      ${Department},
      "placementTitles": *[_type == "employee" && defined(placements)].placements[]->title | order(asc)

  }
`;
